import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as surveyService from '../../../services/survey-service';
import * as reviewService from '../../../services/review-service'

const initialState = {
    questions: [],
    status: 'idle',
    error: null,


    //post survey-questions   
    postSurveyQuestionnaireStatus: 'idle',
    postSurveyQuestionnaireError: null,
    //review task
    reviewTask: {},
    reviewTaskStatus: 'idle',
    reviewTaskError: null,
    //review booking
    reviewBooking: {},
    reviewBookingStatus: 'idle',
    reviewBookingError: null,

    //survey answers
    surveyAnswers: [],
    surveyAnswersStatus: 'idle',
    surveyAnswersError: null,

    //survey send stats (sent vs answered)
    surveySendStats: null,
    surveySendStatsStatus: 'idle',
    surveySendStatsError: null,

    addSurveyAnswersStatus: 'idle',
    addSurveyAnswersError: null,
    submittedSurveyAnswer: null,

    updateSurveyStatus: 'idle',
    updateSurveyError: null,

    //selectedSurvey
    selectedSurveyQuestionnair: { label: "ALL", value: "ALL" },
    totalRows: 0,

    //pax survey questions (by language)
    paxQuestions: [],
    getPaxQuestionsStatus: "idle",
    getPaxQuestionsError: null,

    surveyById: null,
    getSurveyByIdStatus: "idle",
    getSurveyByIdError: null,

    answersReport: [],
    getAnswersReportStatus: "idle",
    getAnswersReportError: null,

    bookingReview: {},
    bookingReviewStatus: "idle",
    bookingReviewError: null,
    selectedPassengerId: null,
    flightDetails: {
        flightNumber: "",
        paxName: "",
        departureDate: "",
    }
};
//#region survey questionnaire

export const getQuestions = createAsyncThunk('reviewControlPanel/getQuestions', async (props) => {

    return surveyService.getQuestions(props);
});

export const getSurveyById = createAsyncThunk('reviewControlPanel/getSurveyById', async (props) => {

    return surveyService.getSurveyIdService(props);
});
export const postSurveyQuestionnaire = createAsyncThunk('reviewControlPanel/postSurveyQuestionnaire', async (props) => {

    return surveyService.postSureveyQuestionnaireService(props);
});

export const getReviewTask = createAsyncThunk('reviews/getReviewTask', async (taskId) => {

    return surveyService.getTaskService(taskId)
})
export const getReviewBooking = createAsyncThunk('reviews/getReviewBooking', async (taskId) => {

    return surveyService.getBookingService(taskId)
})
export const updateSurveyAvailability = createAsyncThunk('reviews/updateSurveyAvailability', async (data) => {

    return surveyService.updateSurveyAvailabilityService(data)
})

export const getPaxQuestions = createAsyncThunk('reviews/getPaxQuestions', async (data) => {

    return surveyService.getPaxSurveyQuestionsService(data)
})
//#endregion

//#region survey Answers
export const postSurveyAnswers = createAsyncThunk('reviews/postSurveyAnswers', async (data) => {

    return surveyService.postSurveyAnswersService(data)
})
export const getSurveyAnswers = createAsyncThunk('reviews/getSurveyAnswers', async (data) => {

    return surveyService.getSurveyAnswersService(data)
})
export const getSurveySendStats = createAsyncThunk('reviews/getSurveySendStats', async (data) => {

    return surveyService.getSurveySendStatsService(data)
})
export const getSurveyAnswersReport = createAsyncThunk('reviews/getSurveyAnswersReport', async (data) => {

    return surveyService.getSurveyAnswersService(data)
})
//#endregion

//#region booking review

export const postBookingReview = createAsyncThunk('reviews/postBookingReview', async (review) => {


    return reviewService.postBookingReview(review)
})
//#endregion



//#region slice
const reviewControlPanelSlice = createSlice({
    name: 'reviewControlPanel',
    initialState,
    reducers: {
        reset: (state) => initialState,
        updateQuestions: (state, action) => {
            state.questions = action.payload;
        },
        setSelectedSurveyQuestionnair: (state, action) => {
            state.selectedSurveyQuestionnair = action.payload;
        },
        resetPostSurveyFlags: (state, action) => {
            state.postSurveyQuestionnaireStatus = 'idle';
            state.postSurveyQuestionnaireError = null;
        },
        resetAddSurveyAnswersStatus: (state, action) => {
            state.addSurveyAnswersStatus = 'idle';
            state.addSurveyAnswersError = null;
        },
        resetAnswersReportFlags: (state) => {
            state.getAnswersReportStatus = 'idle';
            state.getAnswersReportError = null;
        },
        resetPostReviewFlags: state => {
            state.bookingReviewStatus = "idle";
            state.bookingReviewError = null
        },
        setSelectedPassenger: (state, action) => {
            state.selectedPassengerId = action.payload
        },
        setFlightDetails: (state, action) => {
            state.flightDetails = action.payload
        }

    },
    extraReducers: {
        [getQuestions.pending]: (state, action) => {
            return {
                ...state,
                status: 'loading',
            }
        },
        [getQuestions.fulfilled]: (state, action) => {

            return {
                ...state,
                status: 'succeeded',
                questions: action.payload
            }
        },
        [getQuestions.rejected]: (state, action) => {
            return {
                ...state,
                status: 'failed',
                error: action.error.message,
            }
        },
        [getSurveyById.pending]: (state, action) => {
            return {
                ...state,
                getSurveyByIdStatus: 'loading',
            }
        },
        [getSurveyById.fulfilled]: (state, action) => {

            return {
                ...state,
                getSurveyByIdStatus: 'succeeded',
                surveyById: action.payload
            }
        },
        [getSurveyById.rejected]: (state, action) => {
            return {
                ...state,
                getSurveyByIdStatus: 'failed',
                getSurveyByIdError: action.error.message,
            }
        },
        [postSurveyQuestionnaire.pending]: (state, action) => {
            return {
                ...state,
                postSurveyQuestionnaireStatus: 'loading',
            }
        },
        [postSurveyQuestionnaire.fulfilled]: (state, action) => {

            return {
                ...state,
                postSurveyQuestionnaireStatus: 'succeeded',
                // questions: action.payload
            }
        },
        [postSurveyQuestionnaire.rejected]: (state, action) => {
            return {
                ...state,
                postSurveyQuestionnaireStatus: 'failed',
                postSurveyQuestionnaireError: action.error.message,
            }
        },
        [getReviewTask.pending]: (state, action) => {
            return {
                ...state,
                reviewTaskStatus: 'loading',

            }
        },
        [getReviewTask.fulfilled]: (state, action) => {
            return {
                ...state,
                reviewTaskStatus: 'succeeded',
                reviewTask: action.payload,
            }
        },
        [getReviewTask.rejected]: (state, action) => {
            return {
                ...state,
                reviewTaskStatus: 'failed',
                reviewTaskError: action.error.message,
            }
        },
        [getReviewBooking.pending]: (state, action) => {
            return {
                ...state,
                reviewBookingStatus: 'loading',

            }
        },
        [getReviewBooking.fulfilled]: (state, action) => {

            return {
                ...state,
                reviewBookingStatus: 'succeeded',
                reviewBooking: action.payload,
            }
        },
        [getReviewBooking.rejected]: (state, action) => {
            return {
                ...state,
                reviewBookingStatus: 'failed',
                reviewBookingError: action.error.message,
            }
        },
        [postSurveyAnswers.pending]: (state, action) => {
            return {
                ...state,
                addSurveyAnswersStatus: 'loading',

            }
        },
        [postSurveyAnswers.fulfilled]: (state, action) => {

            return {
                ...state,
                addSurveyAnswersStatus: 'succeeded',
                submittedSurveyAnswer: action.payload,
            }
        },
        [postSurveyAnswers.rejected]: (state, action) => {
            return {
                ...state,
                addSurveyAnswersStatus: 'failed',
                addSurveyAnswersError: action.error.message,
            }
        },
        [getSurveyAnswers.pending]: (state, action) => {
            return {
                ...state,
                surveyAnswersStatus: 'loading',

            }
        },
        [getSurveyAnswers.fulfilled]: (state, action) => {

            return {
                ...state,
                surveyAnswersStatus: 'succeeded',
                surveyAnswers: action.payload.rows,
                totalRows: action.payload.totalRows,
            }
        },
        [getSurveyAnswers.rejected]: (state, action) => {
            return {
                ...state,
                surveyAnswersStatus: 'failed',
                surveyAnswersError: action.error.message,
            }
        },
        [getSurveySendStats.pending]: (state, action) => {
            return {
                ...state,
                surveySendStatsStatus: 'loading',
            }
        },
        [getSurveySendStats.fulfilled]: (state, action) => {
            return {
                ...state,
                surveySendStatsStatus: 'succeeded',
                surveySendStats: action.payload,
            }
        },
        [getSurveySendStats.rejected]: (state, action) => {
            return {
                ...state,
                surveySendStatsStatus: 'failed',
                surveySendStatsError: action.error.message,
            }
        },
        [updateSurveyAvailability.pending]: (state, action) => {
            return {
                ...state,
                updateSurveyStatus: 'loading',

            }
        },
        [updateSurveyAvailability.fulfilled]: (state, action) => {

            return {
                ...state,
                updateSurveyStatus: 'succeeded',

            }
        },
        [updateSurveyAvailability.rejected]: (state, action) => {
            return {
                ...state,
                updateSurveyStatus: 'failed',
                updateSurveyError: action.error.message,
            }
        },
        [getPaxQuestions.pending]: (state, action) => {
            return {
                ...state,
                getPaxQuestionsStatus: 'loading',

            }
        },
        [getPaxQuestions.fulfilled]: (state, action) => {
            return {
                ...state,
                getPaxQuestionsStatus: 'succeeded',
                paxQuestions: action.payload,
            }
        },
        [getPaxQuestions.rejected]: (state, action) => {
            return {
                ...state,
                getPaxQuestionsStatus: 'failed',
                getPaxQuestionsError: action.error.message,
            }
        },
        [getSurveyAnswersReport.pending]: (state, action) => {
            return {
                ...state,
                getAnswersReportStatus: 'loading',

            }
        },
        [getSurveyAnswersReport.fulfilled]: (state, action) => {

            return {
                ...state,
                getAnswersReportStatus: 'succeeded',
                answersReport: action.payload,
            }
        },
        [getSurveyAnswersReport.rejected]: (state, action) => {
            return {
                ...state,
                getAnswersReportStatus: 'failed',
                getAnswersReportError: action.error.message,
            }
        },
        [postBookingReview.pending]: (state, action) => {
            return {
                ...state,
                bookingReviewStatus: 'loading',

            }
        },
        [postBookingReview.fulfilled]: (state, action) => {

            return {
                ...state,
                bookingReviewStatus: 'succeeded',
                bookingReview: action.payload,
            }
        },
        [postBookingReview.rejected]: (state, action) => {
            return {
                ...state,
                bookingReviewStatus: 'failed',
                bookingReviewError: action.error.message,
            }
        }

    }
});

//#endregion

//#region Actions
export const { reset, updateQuestions, setSelectedSurveyQuestionnair, resetPostSurveyFlags, resetAddSurveyAnswersStatus, resetAnswersReportFlags, resetPostReviewFlags, setSelectedPassenger, setFlightDetails } = reviewControlPanelSlice.actions;
//#endregion 


//#region selectors

export const selectQuestions = state => {
    //console.log('in state: ', state.reviewControlPanel.questions)
    return state.reviewControlPanel.questions;
}
export const selectSurveyById = state => state.reviewControlPanel.surveyById;
export const selectQuestionsStatus = state => state.reviewControlPanel.status;


export const selectReviewTask = state => state.reviewControlPanel.reviewTask;
export const selectReviewTaskStatus = state => state.reviewControlPanel.reviewTaskStatus;

export const selectReviewBooking = state => state.reviewControlPanel.reviewBooking;
export const selectReviewBookingStatus = state => state.reviewControlPanel.reviewBookingStatus;

export const selectSurveyAnswers = state => state.reviewControlPanel.surveyAnswers;
export const selectTotalRows = state => state.reviewControlPanel.totalRows;
export const selectSurveyAnswersStatus = state => state.reviewControlPanel.surveyAnswersStatus;
export const selectSurveySendStats = state => state.reviewControlPanel.surveySendStats;
export const selectSurveySendStatsStatus = state => state.reviewControlPanel.surveySendStatsStatus;

export const selectSelectedSurveyQuestionnair = state => state.reviewControlPanel.selectedSurveyQuestionnair;
export const selectPostQuestionnaireStatus = state => state.reviewControlPanel.postSurveyQuestionnaireStatus;

export const selectUpdateSurveyStatus = state => state.reviewControlPanel.updateSurveyStatus;

export const selectPaxQuestions = state => state.reviewControlPanel.paxQuestions;
export const selectPaxQuestionsStatus = state => state.reviewControlPanel.getPaxQuestionsStatus;

export const selectSubmitSurveyAnswersStatus = state => state.reviewControlPanel.addSurveyAnswersStatus;
export const selectSubmittedSurveyAnswers = state => state.reviewControlPanel.submittedSurveyAnswer;

export const selectAnswersReportStatus = state => state.reviewControlPanel.getAnswersReportStatus;
export const selectAnswersReport = state => state.reviewControlPanel.answersReport;

export const selectPostBookingReview = state => state.reviewControlPanel.bookingReview;
export const selectPostBookingReviewStatus = state => state.reviewControlPanel.bookingReviewStatus;
export const selectedPassenger = state => state.reviewControlPanel.selectedPassengerId;
export const selectFlightDetails = state => state.reviewControlPanel.flightDetails;
//#endregion
export default reviewControlPanelSlice.reducer;
